
const imageUrl = (title) => {
  return `/imgs/erp/${title}.png`;
};

const banner = {
  title: '云ERP系统',
  description: '为贸易型中小企业打造，流程极简、高性价比、全链可视针对B2B的云进销存系统。',
  img: imageUrl('banner')
};

const value = [
  {
    title: '全面管理',
    items: [
      '涵盖采购/销售/库存/客户及供应商账务等完整业务场景，使用简单，管控轻松。',
    ]
  },
  {
    title: '降低风险',
    items: [
      '通过库存预警及时合理安排补货或促销，降低脱销/滞销风险；通过账务管理及时掌握账务情况，防止账务混乱。',
    ]
  },
  {
    title: '提高效率',
    items: [
      '各类业务单据支持快捷导入及快速生成；商品信息快速录入、智能归类。',
    ]
  }
];

const func = [
  {
    title: '订单管理',
    img: imageUrl('func1'),
    description: '采购/销售订单正逆向流程全面灵活管理，实时监控订单执行'
  },
  {
    title: '库存管理',
    img: imageUrl('func2'),
    description: '依单作业，商品进出清晰明了，库存动态实时可见,通过库存预警及时合理补货'
  },
  {
    title: '调度委托',
    img: imageUrl('func3'),
    description: '支持物流委派及执行跟踪，物流过程透明'
  },
  {
    title: '账务管理',
    img: imageUrl('func4'),
    description: '避免错账漏账，财务数据管控清晰，经营状况实时掌握'
  },
  {
    title: '统计分析',
    img: imageUrl('func5'),
    description: '可生成各类进货、销售分析及统计报表，为企业经营决策提供数据依据'
  }
];

const structure = imageUrl('structure');

export {banner, value, func, structure};


// WEBPACK FOOTER //
// ./src/routes/ProductERP/config.js